import {provideContext1}    from "@Common/react/context";
import {Link}               from "@Common/react/cst2";

const SVG_STORE:Record<string, Promise<string>> = {};

export const loadSvgThumbnailsCache = (next: Link<React.ReactNode, any>) => (
    provideContext1("svgThumbnailsCache", {
        loadUrl: async (url: string) =>
        {
            if (!(url in SVG_STORE)) {
                SVG_STORE[url] = fetch(url, {cache: "reload"}).then(response =>
                {
                    if (!response.ok) {
                        throw response;
                    }
                    return response.text();
                });
            }

            return SVG_STORE[url];
        },
    }, next)
);

